import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0276ebfc")

_pushScopeId("data-v-0276ebfc")
const _hoisted_1 = {
  id: "aw-sl",
  style: {"font-size":"1em !important"}
}
const _hoisted_2 = { class: "forNarrow" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", { class: "full-video-label" }, "Full Video", -1)
const _hoisted_5 = { class: "rnd-crns margin-bottom" }
const _hoisted_6 = { class: "rnd-crns" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createVNode("h3", { class: "full-video-label" }, "Full Video", -1)
const _hoisted_9 = { class: "rnd-crns" }
const _hoisted_10 = { id: "parmonic-resources" }
const _hoisted_11 = { id: "parmonic-speakers" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SeoJsonLdComponentVue = _resolveComponent("SeoJsonLdComponentVue")
  const _component_TranslationDropdown = _resolveComponent("TranslationDropdown")
  const _component_TheaterPlayer = _resolveComponent("TheaterPlayer")
  const _component_MAGate = _resolveComponent("MAGate")
  const _component_TitleTrailerCompoent = _resolveComponent("TitleTrailerCompoent")
  const _component_SliderLayout = _resolveComponent("SliderLayout")
  const _component_VideoPlayer = _resolveComponent("VideoPlayer")
  const _component_IframeVideoPlayer = _resolveComponent("IframeVideoPlayer")
  const _component_RelatedResourceComponent = _resolveComponent("RelatedResourceComponent")
  const _component_SpeakerSection = _resolveComponent("SpeakerSection")
  const _component_SliderSkeleton = _resolveComponent("SliderSkeleton")

  return (_openBlock(), _createBlock("div", {
    id: "aw--c",
    style: _ctx.themeCss
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.webinarInfo != undefined)
        ? (_openBlock(), _createBlock(_component_SeoJsonLdComponentVue, {
            key: 0,
            webinarInfo: _ctx.webinarInfo
          }, null, 8, ["webinarInfo"]))
        : _createCommentVNode("", true),
      (_ctx.webinarInfo != undefined)
        ? (_openBlock(), _createBlock(_component_TranslationDropdown, {
            key: 1,
            languages: _ctx.webinarInfo.translation_language_codes
          }, null, 8, ["languages"]))
        : _createCommentVNode("", true),
      (_ctx.webinarInfo && _ctx.lightboxVideos && _ctx.lightboxVideos.length > 0 && _ctx.usetheaterMode == true)
        ? (_openBlock(), _createBlock(_component_TheaterPlayer, {
            key: 2,
            videos: _ctx.lightboxVideos,
            logoOverlay: _ctx.webinarInfo.overlay_logo,
            useDemoOverlay: _ctx.webinarInfo.use_demo_overlay,
            themeCss: _ctx.themeCss,
            ma: _ctx.webinarInfo.ma,
            cta: _ctx.webinarInfo.cta,
            isGated: _ctx.webinarInfo.is_gated,
            post_play: _ctx.webinarInfo.post_play
          }, null, 8, ["videos", "logoOverlay", "useDemoOverlay", "themeCss", "ma", "cta", "isGated", "post_play"]))
        : _createCommentVNode("", true),
      (_ctx.webinarInfo != undefined)
        ? (_openBlock(), _createBlock("div", {
            key: _ctx.webinarInfo.video_urls.dash_url
          }, [
            _createVNode(_component_MAGate, {
              ma: _ctx.webinarInfo.ma,
              themeCss: _ctx.themeCss
            }, null, 8, ["ma", "themeCss"]),
            (_ctx.webinarInfo.is_info_tab_visible == true)
              ? (_openBlock(), _createBlock(_component_TitleTrailerCompoent, {
                  key: 0,
                  widgetData: _ctx.webinarInfo,
                  usetheaterMode: _ctx.usetheaterMode
                }, null, 8, ["widgetData", "usetheaterMode"]))
              : _createCommentVNode("", true),
            _createVNode(_component_SliderLayout, {
              webinarInfo: _ctx.webinarInfo,
              class: "forWide",
              usetheaterMode: _ctx.usetheaterMode
            }, null, 8, ["webinarInfo", "usetheaterMode"]),
            _createVNode("div", _hoisted_2, [
              (_ctx.webinarInfo.is_full_video_visible == true && _ctx.webinarInfo.is_full_video_on_top == true)
                ? (_openBlock(), _createBlock("div", _hoisted_3, [
                    _hoisted_4,
                    _createVNode("div", _hoisted_5, [
                      (!_ctx.webinarInfo.video_urls.iframe_url || _ctx.webinarInfo.video_urls.iframe_url == '')
                        ? (_openBlock(), _createBlock(_component_VideoPlayer, {
                            key: 0,
                            poster: _ctx.webinarInfo.video_urls.poster_url,
                            video_urls: _ctx.webinarInfo.video_urls,
                            subtitleUrls: _ctx.webinarInfo.subtitle_urls,
                            subtitles: _ctx.webinarInfo.subtitles,
                            duration: _ctx.webinarInfo.duration,
                            videoType: _ctx.ContentType.Webinar,
                            title: _ctx.translateWebinar(_ctx.webinarInfo).title,
                            useDemoOverlay: _ctx.webinarInfo.use_demo_overlay,
                            logoOverlay: _ctx.webinarInfo.overlay_logo,
                            isgated: _ctx.webinarInfo.is_gated,
                            ma: _ctx.webinarInfo.ma,
                            usetheaterMode: _ctx.usetheaterMode,
                            post_play: _ctx.webinarInfo.post_play,
                            share_buttons: _ctx.webinarInfo.share_buttons
                          }, null, 8, ["poster", "video_urls", "subtitleUrls", "subtitles", "duration", "videoType", "title", "useDemoOverlay", "logoOverlay", "isgated", "ma", "usetheaterMode", "post_play", "share_buttons"]))
                        : (_openBlock(), _createBlock(_component_IframeVideoPlayer, {
                            key: 1,
                            iframe_url: _ctx.webinarInfo.video_urls.iframe_url,
                            poster: _ctx.webinarInfo.video_urls.poster_url,
                            duration: _ctx.webinarInfo.duration
                          }, null, 8, ["iframe_url", "poster", "duration"]))
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.webinarInfo.moments, (m, i) => {
                return (_openBlock(), _createBlock("div", {
                  class: "video-holder",
                  id: 'moment-' + m.id,
                  key: i
                }, [
                  _createVNode("div", _hoisted_6, [
                    (!m.video_urls.iframe_url || m.video_urls.iframe_url == '')
                      ? (_openBlock(), _createBlock(_component_VideoPlayer, {
                          key: 0,
                          poster: m.video_urls.poster_url,
                          video_urls: m.video_urls,
                          subtitleUrls: m.subtitle_urls,
                          subtitles: m.subtitles,
                          continuefromTime: m.end_time,
                          duration: m.duration,
                          videoType: _ctx.ContentType.Moment,
                          title: _ctx.translateMoment(m).title,
                          mid: m.id,
                          useDemoOverlay: _ctx.webinarInfo.use_demo_overlay,
                          logoOverlay: _ctx.webinarInfo.overlay_logo,
                          isgated: _ctx.webinarInfo.is_gated,
                          ma: _ctx.webinarInfo.ma,
                          usetheaterMode: _ctx.usetheaterMode
                        }, null, 8, ["poster", "video_urls", "subtitleUrls", "subtitles", "continuefromTime", "duration", "videoType", "title", "mid", "useDemoOverlay", "logoOverlay", "isgated", "ma", "usetheaterMode"]))
                      : (_openBlock(), _createBlock(_component_IframeVideoPlayer, {
                          key: 1,
                          iframe_url: m.video_urls.iframe_url,
                          poster: m.video_urls.poster_url,
                          duration: m.duration
                        }, null, 8, ["iframe_url", "poster", "duration"]))
                  ]),
                  _createVNode("div", null, [
                    (m.title)
                      ? (_openBlock(), _createBlock("p", {
                          key: 0,
                          innerHTML: _ctx.translateMoment(m).title,
                          class: "mom-t"
                        }, null, 8, ["innerHTML"]))
                      : _createCommentVNode("", true),
                    _createVNode("div", {
                      innerHTML: _ctx.translateMoment(m).description,
                      class: "mom-d"
                    }, null, 8, ["innerHTML"])
                  ])
                ], 8, ["id"]))
              }), 128)),
              (_ctx.webinarInfo.is_full_video_visible == true && _ctx.webinarInfo.is_full_video_on_top != true)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode("div", _hoisted_9, [
                      (!_ctx.webinarInfo.video_urls.iframe_url || _ctx.webinarInfo.video_urls.iframe_url == '')
                        ? (_openBlock(), _createBlock(_component_VideoPlayer, {
                            key: 0,
                            poster: _ctx.webinarInfo.video_urls.poster_url,
                            video_urls: _ctx.webinarInfo.video_urls,
                            subtitleUrls: _ctx.webinarInfo.subtitle_urls,
                            subtitles: _ctx.webinarInfo.subtitles,
                            duration: _ctx.webinarInfo.duration,
                            videoType: _ctx.ContentType.Webinar,
                            title: _ctx.translateWebinar(_ctx.webinarInfo).title,
                            useDemoOverlay: _ctx.webinarInfo.use_demo_overlay,
                            logoOverlay: _ctx.webinarInfo.overlay_logo,
                            isgated: _ctx.webinarInfo.is_gated,
                            ma: _ctx.webinarInfo.ma,
                            usetheaterMode: _ctx.usetheaterMode,
                            post_play: _ctx.webinarInfo.post_play
                          }, null, 8, ["poster", "video_urls", "subtitleUrls", "subtitles", "duration", "videoType", "title", "useDemoOverlay", "logoOverlay", "isgated", "ma", "usetheaterMode", "post_play"]))
                        : (_openBlock(), _createBlock(_component_IframeVideoPlayer, {
                            key: 1,
                            iframe_url: _ctx.webinarInfo.video_urls.iframe_url,
                            poster: _ctx.webinarInfo.video_urls.poster_url,
                            duration: _ctx.webinarInfo.duration
                          }, null, 8, ["iframe_url", "poster", "duration"]))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_RelatedResourceComponent, {
                resources: _ctx.webinarInfo.related_resources
              }, null, 8, ["resources"])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_SpeakerSection, {
                speakers: _ctx.webinarInfo.speakers
              }, null, 8, ["speakers"])
            ])
          ]))
        : (_openBlock(), _createBlock(_component_SliderSkeleton, {
            key: 4,
            loadingmsg: _ctx.loadingmsg
          }, null, 8, ["loadingmsg"]))
    ])
  ], 4))
})